import React, { useEffect, useState, useContext } from "react";
import {
  getSkillStoreData,
  getSkillDepartmentData,
  getSkillScopeData,
  getSkillStoreDataById,
} from "../../../services/skillStoreService";
import loaderContext from "../../../../../../context/loader/loaderContext";
import TabLink from "../../../../promptManagement/views/_partials/tabLink";
import SkillStore from "../skillstore";
import ThirdPartyAIToolsSkills from "../thirdPartyAIToolsSkills";
import { UserContext } from "../../../../../../context/user/userContext";

const Skills = ({ IsThirdPartyAITool, limit }) => {
  const [originalSkills, setOriginalSkills] = useState([]);

  const { updateLoaderStatus } = useContext(loaderContext);
  const { state } = useContext(UserContext);
  const userId = state?.user?.userProfile?.user_id;
  const [skillDepartmentData, setSkillDepartmentData] = useState([]);
  const [skillStoreScopeData, setSkillStoreScopeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getDataOfSkillDep = async () => {
      const data = await getSkillDepartmentData();
      setSkillDepartmentData(data);
    };

    const getDataOfSkillScope = async () => {
      const data = await getSkillScopeData();
      setSkillStoreScopeData(data);
    };

    const getDataOfSkillStore = async () => {
      setIsLoading(true);
      updateLoaderStatus(true);
      const data = await getSkillStoreData();
      if (!IsThirdPartyAITool) {
        if (state?.user?.userProfile?.userMSALRole?.toLowerCase() === "owner") {
          const filteredSkills = data.filter((item) => {
            if (item.IsFabricAI && !item.IsIndexCreated) {
              return false;
            }
            else if (item.IsFabricAI && item.IsIndexCreated) {
              return true;
            }
            else
              return true;


          });
          setOriginalSkills(filteredSkills);
        } else {

          const filteredSkills = data.filter((item) => {


            if (!item.IsVisibleToUser && !item.FabricAI) {
              // If not visible, include the item directly
              return true;
            }
            if (item.IsFabricAI && !item.IsIndexCreated) {
              return false;
            }
            else if (item.IsFabricAI && item.IsIndexCreated) {
              return true;
            }
            else
              return true;



            // If visible, apply the security group or owner filter
            const isInSecurityGroup =
              state?.user?.userProfile?.msalSecurityGroup?.some(
                (group) => group.id === item.SecurityGroupId
              );

            const isOwner = item?.Owner?.includes(userId);

            return isInSecurityGroup || isOwner;
          });
          setOriginalSkills(filteredSkills);
        }
      } else {
        setOriginalSkills(data);
      }
      setIsLoading(false);
      updateLoaderStatus(false);
    };

    getDataOfSkillDep();
    getDataOfSkillScope();
    getDataOfSkillStore();
  }, []);

  const updateOriginalData = (skillId) => {
    getSkillStoreDataById(skillId).then((res) => {
      setOriginalSkills((prevData) =>
        prevData.map((item) =>
          item.Id === skillId ? { ...item, UsedCount: res.UsedCount } : item
        )
      );
    });
  };

  return (
    <div className="dash-section ">
      <div className="skills-tabs w-tabs">
        <div className="w-tab-content">
          {!IsThirdPartyAITool && (
            <SkillStore
              limit={limit}
              originalSkills={originalSkills}
              skillDepartmentData={skillDepartmentData}
              skillStoreScopeData={skillStoreScopeData}
              IsThirdPartyAITool={IsThirdPartyAITool}
              setOriginalSkills={setOriginalSkills}
              isLoading={isLoading}
            ></SkillStore>
          )}
          {IsThirdPartyAITool && (
            <ThirdPartyAIToolsSkills
              limit={limit}
              originalSkills={originalSkills}
              skillDepartmentData={skillDepartmentData}
              skillStoreScopeData={skillStoreScopeData}
              IsThirdPartyAITool={IsThirdPartyAITool}
              setOriginalSkills={setOriginalSkills}
              updateOriginalData={updateOriginalData}
              isLoading={isLoading}
            ></ThirdPartyAIToolsSkills>
          )}
        </div>
      </div>
    </div>
  );
};

export default Skills;
